<div class="interventions-container">
  <!-- Compact header with title, toolbar and tabs combined -->
  <div class="header-container">
    <p-toolbar styleClass="compact-toolbar p-0 surface-0">
      <div class="p-toolbar-group-start flex flex-row align-items-center">
        <div class="inline-tabs">
          <p-tabs [(value)]="activeTab" styleClass="society-tabs">
            <p-tablist>
              @for (tab of mlSocieties; track tab.id) {
                <p-tab [value]="tab.id">
                  <div class="tab-header">
                    <i class="{{ tab.icon }} mr-2"></i>
                    <p-badge
                      [value]="
                        tab.id === _activeTab
                          ? getCurrentSocietyCount()
                          : societyCounts[tab.id] || 0
                      "
                      severity="info"
                      styleClass="ml-2"
                    >
                    </p-badge>
                  </div>
                </p-tab>
              }
            </p-tablist>
          </p-tabs>
        </div>
      </div>

      <div
        *ngIf="filtersOpened"
        style="display: flex; gap: 20px; align-items: center"
      >
        <p-iconfield iconPosition="left">
          <p-inputicon styleClass="pi pi-search" />
          <p-select
            [filter]="true"
            [options]="allInterventionStatus"
            placeholder="Statut intervention"
            class="w-full md:w-56"
            [(ngModel)]="selectedInterventionStatus"
            (onChange)="applyFilters()"
          />
        </p-iconfield>
        <p-select
          [filter]="true"
          [options]="allAssistants"
          placeholder="Assistant"
          class="w-full md:w-56"
          [(ngModel)]="selectedAssistant"
          (onChange)="applyFilters()"
        />
        <p-select
          [filter]="true"
          [options]="allTechnicians"
          placeholder="Technicien"
          class="w-full md:w-56"
          [(ngModel)]="selectedTechnician"
          (onChange)="applyFilters()"
        />
        <p-select
          [filter]="true"
          [options]="allProducts"
          placeholder="Produit"
          class="w-full md:w-56"
          [(ngModel)]="selectedProduct"
          (onChange)="applyFilters()"
        />
        <p-button
          icon="pi pi-times"
          styleClass="p-button-outlined p-button-rounded mr-2"
          (click)="resetFilters()"
          pTooltip="Effacer"
        ></p-button>
      </div>

      <ng-template #end>
        <p-button
          icon="pi pi-sync"
          styleClass="p-button-outlined p-button-rounded mr-2"
          (click)="refreshData()"
          [loading]="(loading$ | async) || false"
          pTooltip="Rafraîchir"
        ></p-button>
        <p-button
          icon="pi pi-filter"
          styleClass="p-button-outlined p-button-rounded"
          [ngStyle]="{
            'background-color': filtersOpened
              ? 'hsl(158.32deg 61.26% 50.39% / 26%)'
              : 'transparent',
            'border-radius': '50%',
          }"
          pTooltip="Filtres avancés"
          (click)="filtersOpened = !filtersOpened"
        ></p-button>
      </ng-template>
    </p-toolbar>
  </div>

  <!-- Main content card -->
  <p-card styleClass="interventions-card">
    <!-- Data table with fixed headers -->
    <p-table
      #dt
      [value]="(incomingInterventions$ | async) || []"
      [lazy]="true"
      [paginator]="true"
      [rows]="10"
      [rowsPerPageOptions]="[5, 10, 20, 50]"
      [totalRecords]="(totalRecords$ | async) || 0"
      [loading]="(loading$ | async) || false"
      styleClass="p-datatable-sm fixed-header-table"
      [rowHover]="true"
      [scrollable]="true"
      scrollHeight="650px"
      [scrollDirection]="'vertical'"
      responsiveLayout="scroll"
      (onLazyLoad)="lazyLoadEmit($event)"
    >
      <ng-template pTemplate="header">
        <tr>
          <th>Référence ML</th>
          <th>Intervention</th>
          <th>Date</th>
          <th>Adresse</th>
          <th>Assistant(e)</th>
          <th>Technicien(ne)s</th>
          <th>Statut</th>
          <th>Actions</th>
        </tr>
        <tr>
          <th>
            <input
              pInputText
              type="text"
              (input)="onColumnFilter($event, 'affairMlRef')"
              placeholder="Rechercher"
              class="p-column-filter"
            />
          </th>
          <th>
            <input
              pInputText
              type="text"
              (input)="onColumnFilter($event, 'name')"
              placeholder="Rechercher"
              class="p-column-filter"
            />
          </th>
          <th>
            <input
              pInputText
              type="text"
              (input)="onColumnFilter($event, 'startDate')"
              placeholder="Rechercher"
              class="p-column-filter"
            />
          </th>
          <th>
            <input
              pInputText
              type="text"
              (input)="onColumnFilter($event, 'address')"
              placeholder="Rechercher code postal ou ville"
              class="p-column-filter"
            />
          </th>
          <th>
            <p-select
              [filter]="true"
              [options]="allAssistants"
              placeholder="Sélectionner"
              class="w-full"
              (onChange)="applyFilters()"
              [(ngModel)]="selectedAssistant"
            />
          </th>
          <th>
            <p-select
              [filter]="true"
              [options]="allTechnicians"
              placeholder="Sélectionner"
              class="w-full"
              (onChange)="applyFilters()"
              [(ngModel)]="selectedTechnician"
            />
          </th>
          <th>
            <p-select
              [filter]="true"
              [options]="allInterventionStatus"
              placeholder="Sélectionner"
              class="w-full"
              (onChange)="onStatusFilterChange()"
              [(ngModel)]="selectedStatus"
            />
          </th>
          <th>
            <button
              pButton
              type="button"
              icon="pi pi-filter-slash"
              class="p-button-outlined p-button-sm clear-filters-btn"
              (click)="clearAllFilters()"
              pTooltip="Effacer tous les filtres"
            ></button>
          </th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-intervention>
        <tr class="cursor-pointer">
          <td (click)="navigateToAffair(intervention)">
            <div class="flex align-items-center">
              <p-tag
                severity="info"
                [value]="intervention.affairMlRef"
                styleClass="mr-2"
              ></p-tag>
            </div>
          </td>
          <td (click)="navigateToIntervention(intervention)">
            <div class="intervention-name">
              <span class="font-medium">{{ intervention.name }}</span>
            </div>
          </td>
          <td (click)="navigateToIntervention(intervention)">
            <div class="date-info">
              <i class="pi pi-calendar mr-2 text-primary"></i>
              <span>{{ intervention.startDate | date: 'dd/MM HH:mm' }}</span>
            </div>
          </td>

          <td (click)="navigateToIntervention(intervention)">
            <div class="address-info">
              <i class="pi pi-map-marker mr-2 text-primary"></i>
              <span>
                {{ intervention.affairWorkSitePostalCode }}
                {{ intervention.affairWorkSiteLocality }}
              </span>
            </div>
          </td>
          <td (click)="navigateToIntervention(intervention)">
            <div>
              <i class="pi pi-user mr-2 text-primary"></i>
              <span>
                {{ intervention.userAssistant.firstname }}
                {{ intervention.userAssistant.lastname }}
              </span>
            </div>
          </td>
          <td (click)="navigateToIntervention(intervention)">
            <div>
              <i class="pi pi-users mr-2 text-primary"></i>
              <span>
                {{ getTechniciansNames(intervention.usersTechnicians) }}
              </span>
            </div>
          </td>
          <td (click)="navigateToIntervention(intervention)">
            <p-tag
              *ngIf="getStatusName(intervention.interventionStatus).toLowerCase().includes('confirmé')"
              severity="success"
              [value]="getStatusName(intervention.interventionStatus)">

            </p-tag>
            <p-tag
              *ngIf="!getStatusName(intervention.interventionStatus).toLowerCase().includes('confirmé')"
              severity="danger"
              [value]="getStatusName(intervention.interventionStatus)">

            </p-tag>
          </td>
          <td>
            <div class="flex justify-content-center gap-2">
              <p-button
                icon="pi pi-eye"
                styleClass="p-button-rounded p-button-text p-button-info"
                pTooltip="Voir dans Planify"
                (click)="viewInterventionDetails(intervention)"
              ></p-button>
              <p-button
                icon="pi pi-external-link"
                styleClass="p-button-rounded p-button-text"
                pTooltip="Ouvrir dans Éros"
                (click)="navigateToIntervention(intervention)"
              ></p-button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="9">
            <div class="flex flex-column align-items-center p-5">
              <i class="pi pi-calendar-minus text-6xl text-500 mb-3"></i>
              <h3 class="m-0 text-500">Aucune intervention à venir</h3>
              <p class="text-500">
                Il n'y a aucune intervention à venir pour le moment.
              </p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-card>
</div>
